import React from 'react'

import { ToolbarTextFlagButton, ArrowContainer } from './ToolbarTextFlagButton'

import { TextFlagState } from './TextFlagButton'
import { upArrowIcon, downArrowIcon } from 'view/components/datagrid/styles/gridIconSet'

interface ToolbarButtonProps {
  state: TextFlagState
  collapsed: boolean
  onClick: () => void
  dataTestId?: string
  text: string
}

export const ToolbarTextFlag: React.FC<ToolbarButtonProps> = ({ state, onClick, dataTestId, text, collapsed }) => {
  return (
    <ToolbarTextFlagButton state={state} onClick={onClick} dataTestId={dataTestId}>
      {text}
      <ArrowContainer>{collapsed ? upArrowIcon : downArrowIcon}</ArrowContainer>
    </ToolbarTextFlagButton>
  )
}
